import React, { useContext } from 'react';
import { Typography, Grid } from '@mui/material';
import { CaseNote, Comment } from 'API';
import { isSameYear, parseISO } from 'date-fns';
import PersonService from 'services/person';
import { timeOrDate } from 'shared/utilities';
import UserContext from 'shared/contexts/UserContext';
import S3Avatar from './S3Avatar';

const { initials, fullname } = PersonService;

interface Props {
  message: CaseNote | Comment;
}

const CommentBubble:React.FC<Props> = ({ message }: Props) => {
  const {
    authorID, authorEmployer, authorTeamMember, note, createdAt,
  } = message;
  const { authorForeignNational } = message as Comment;
  const [userState] = useContext(UserContext);
  const { person } = userState;

  const isOwn = authorID === person.id;

  const author = authorEmployer || authorTeamMember || authorForeignNational;

  return (
    <Grid container sx={{ margin: '8px 0' }}>
      <Grid container justifyContent="flex-start" size={2}>
        {!isOwn && (
          <S3Avatar
            picture={author?.avatar}
            alt={fullname(author)}
            sx={{ alignSelf: 'end', bottom: '1.5rem' }}
            title={fullname(author)}
          >
            {initials(author)}
          </S3Avatar>
        )}
      </Grid>
      <Grid
        container
        alignItems="center"
        justifyContent={isOwn ? 'flex-end' : 'flex-start'}
        size={8}>
        <div>
          {!isOwn && (
            <Typography
              variant="caption"
              sx={(t) => ({ color: t.palette.grey4, marginTop: t.spacing(0.5), display: 'block' })}
              align={isOwn ? 'right' : 'left'}
            >
              {fullname(author)}
            </Typography>
          )}
          <Typography
            sx={(t) => ({
              border: `1px solid ${t.palette.grey3}`,
              borderRadius: isOwn ? '10px 10px 0 10px' : '10px 10px 10px 0',
              padding: t.spacing(1),
              whiteSpace: 'pre-line',
              ...(isOwn && {
                backgroundColor: t.palette.primary1,
                color: t.palette.grey1,
              }),
            })}
          >
            {note}
          </Typography>
          {createdAt && (
            <Typography
              variant="caption"
              sx={(t) => ({ color: t.palette.grey4, marginTop: t.spacing(0.5), display: 'block' })}
              align={isOwn ? 'right' : 'left'}
            >
              {timeOrDate(createdAt,
                "'Today at' h:mm aaa zzz",
                `${isSameYear(parseISO(createdAt), new Date())
                  ? 'MMM d '
                  : 'MMM d, yyyy, '}'at ' h:mm aaa zzz`)}
            </Typography>
          )}
        </div>
      </Grid>
      <Grid container justifyContent="flex-end" size={2}>
        {isOwn && (
          <S3Avatar
            picture={author?.avatar}
            alt={fullname(author)}
            sx={{ alignSelf: 'end', bottom: '1.5rem' }}
            title={fullname(author)}
          >
            {initials(author)}
          </S3Avatar>
        )}
      </Grid>
    </Grid>
  );
};

export default CommentBubble;
